export var enquiresData = [
  {
    id:'en-1',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    created_at:'2021-02-03 21:19'
  },

  {
    id:'en-2',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    created_at:'2021-02-03 21:19'
  },

  {
    id:'en-3',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    created_at:'2021-02-03 21:19'
  },

  {
    id:'en-4',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    already_read:true,
    created_at:'2021-02-03 21:19'
  },

  {
    id:'en-5',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    already_read:true,
    created_at:'2021-02-03 21:19'
  },

  {
    id:'en-6',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    already_read:true,
    created_at:'2021-02-03 21:19'
  },

  {
    id:'en-7',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    already_read:true,
    created_at:'2021-02-03 21:19'
  },

  {
    id:'en-8',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    already_read:true,
    created_at:'2021-02-03 21:19'
  },

  {
    id:'en-9',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    already_read:true,
    created_at:'2021-02-03 21:19'
  },

  {
    id:'en-10',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    already_read:true,
    created_at:'2021-02-03 21:19'
  },

  {
    id:'en-11',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    already_read:true,
    created_at:'2021-02-03 21:19'
  },

  {
    id:'en-12',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    already_read:true,
    created_at:'2021-02-03 21:19'
  },

  {
    id:'en-13',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    already_read:true,
    created_at:'2021-02-03 21:19'
  },

  {
    id:'en-14',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    already_read:true,
    created_at:'2021-02-03 21:19'
  },

  {
    id:'en-15',
    name:'Martin Aha',
    email:'haha@mi.com',
    company:'Xiao mi Tech co.,ltd',
    content:`Here's the high-level recipe for how we expect DirectML to be used. 
      Within the two main phases of initialization and execution, 
      you record work into command lists and then you execute them on a queue.`,
    already_read:true,
    created_at:'2021-02-03 21:19'
  },

]